import { SerpStatusGq } from './SerpStatusGq';

export interface SerpTrackingRequestGq {
  serpStatus: SerpStatusGq;
  serpTrackingTaskTime: string;
  projectRequestId: number;
}

export const SerpTrackingRequestGqProps = `
  serpStatus
  serpTrackingTaskTime
  projectRequestId
`;
